export default __webpack_public_path__ + "static/dummyRoundOne-e8067c05b0ff8fa73890b19e1aa15797.webp";